import {DETERMINAR_PAGINA_ATUAL_PRESTADOR} from '../types'

export default function determinarPaginaAtualPrestador (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_PRESTADOR,
    payload: paginaAtual
  }
}
